<div class="card">
    <p-card>
        <ng-template pTemplate="header">
            <div class="flex flex-row flex-row-reverse p-1 pr-6">
                <p-button *ngIf="activeSubmission" icon="pi pi-file-import" [rounded]="true" [text]="true" [raised]="true" (onClick)="fillFromSubmission()"></p-button>
                <p-button icon="pi pi-eraser" [rounded]="true" [text]="true" [raised]="true" (onClick)="clearForm()" class="mr-2 ml-2"></p-button>
            </div>
        </ng-template>
        <div class="grid formgrid p-fluid">
            <div class="field mt-2 col-12">
                <span>
                    <p-floatLabel>
                        <input id="CarrierName" pInputText [(ngModel)]="carrier.name" />
                        <label for="CarrierName">Carrier Name</label>
                    </p-floatLabel>
                </span>
            </div>
            <div *ngIf="carrier.companyLocation" class="flex flex-column col-12">
                <div class="w-full m-1 p-1">
                    <div class="field">
                        <p-floatLabel>
                            <input id="street1" pInputText [(ngModel)]="carrier.companyLocation.street1" class="w-full"/>
                            <label for="street1">Street 1</label>
                        </p-floatLabel>
                    </div>
                    <div class="field pt-2">
                        <p-floatLabel>
                            <input id="street2" pInputText [(ngModel)]="carrier.companyLocation.street2" class="w-full" />
                            <label for="street2">Street 2</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex grid">
                        <div class="field col-6 pt-2">
                            <p-floatLabel>
                                <input id="city" pInputText [(ngModel)]="carrier.companyLocation.city" class="w-full"/>
                                <label for="city">City</label>
                            </p-floatLabel>
                        </div>
                        <div class="field col-3 pt-2">
                            <p-floatLabel>
                                <input id="state" pInputText [(ngModel)]="carrier.companyLocation.state" class="w-full"/>
                                <label for="state">State</label>
                            </p-floatLabel>
                        </div>
                        <div class="field col-3 pt-2">
                            <p-floatLabel>
                                <input id="zipCode" pInputText [(ngModel)]="carrier.companyLocation.zipCode" class="w-full"/>
                                <label for="zipCode">Zip</label>
                            </p-floatLabel>
                        </div>
                        <div class="field col-6 pt-2">
                            <p-floatLabel>
                                <input id="billingEmailAddress" pInputText [(ngModel)]="carrier.billingEmailAddress" class="w-full"/>
                                <label for="billingEmailAddress">Billing Email Address</label>
                            </p-floatLabel>
                        </div>
                    </div>        
                </div> 
            </div>

            <div class="flex mt-2 col-12 justify-content-center" >
                <p-buttonGroup>
                    <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
                </p-buttonGroup>
            </div>
        </div>
        
    </p-card>
</div>